import { IAuthorization } from '@studyportals/scholarships-editor-integration';
import {
	BaseSuperAgentRequestFactory,
	IRequestSender,
	ISuperAgentRequestFactory,
	RequestSender,
} from '@studyportals/mb-platform-http-requests';
import { RequestSenderDecoratorUiLoader } from '../ui-loader/request-sender-decorator-ui-loader';

import { ReflectorResponse } from './reflector-response';

export class ReflectorIntegration {
	private readonly requestSender: IRequestSender;
	private readonly requestFactory: ISuperAgentRequestFactory;

	public constructor() {
		this.requestSender = new RequestSender();
		this.requestSender = new RequestSenderDecoratorUiLoader(this.requestSender);

		this.requestFactory = new BaseSuperAgentRequestFactory();
	}

	protected async send<TData>(
		path: string,
		q: string,
		authorization: IAuthorization
	): Promise<ReflectorResponse<TData>> {
		const uri = `${CONFIG.REFLECTOR_URI}?token=${authorization.token}&path=${path}&q=${q}&length=25`;
		const request = this.requestFactory.get(uri);

		return await this.requestSender.sendAndExtractBody<ReflectorResponse<TData>>(request);
	}

	protected determineSearchQuery(terms: string): string {
		const parts = terms.split(/\s+/);
		const ids = parts.filter((p) => Number.parseInt(p, 10).toString() === p);
		const keywords = parts
			.filter((p) => !ids.includes(p))
			.map((k) => k.trim().toLowerCase())
			.filter((k) => k.length > 0);

		const queries: string[] = [];
		if (ids.length > 0) {
			queries.push(`ids-${ids.join(',')}`);
		}

		if (keywords.length > 0) {
			queries.push(`keywords-${keywords.join(',')}`);
		}

		return queries.join('|');
	}
}
